// WHAT A CHAT THREAD MAY HOLD — shared by the workbench chat (RoadmapView.tsx) and the
// roadmap planner (PlannerChat.tsx), so the two surfaces cannot drift apart on which card
// gets a Hold button.
//
// The kinds a thread card offers Hold for — every kind the accept route can apply on its own
// (conflict stays out: adjudicating a side needs the rail's own controls). This set is what
// makes the queue's conversation exclusion honest: a same-deliverable proposal — and every
// proposal of a LEGACY thread from before runs carried context_ref (prod #478, a
// create_requirement reachable from nowhere) — exists only here, so if the thread did not
// offer the Hold, nothing anywhere would. A kind that ALSO reaches the queue holds from either
// place; the accept route's pending-only guard makes the second attempt a polite 409.
export const HOLDABLE_IN_THREAD = new Set([
  'create_deliverable_item', 'update_deliverable', 'update_deliverable_item', 'create_deliverable',
  'create_requirement', 'create_ac', 'create_test_case', 'provisional', 'open_question',
]);
